import { RevxInputNumber } from 'components/RevxInputNumber';
import { AdjustMarkupPayload } from 'domains/jobconfigDomain';
import { useEffect, useState } from 'react';
import { ComparisonMoney } from './ComparisonMoney';

interface Props {
  charge?: number;
  cancelUpdateMarkup?: () => void;
  updateMarkup?: (payload: AdjustMarkupPayload) => Promise<void>;
  jobConfigId?: string;
  quantityItemSerialNumber?: number;
  comparatorItemSerialNumber?: number;
  boxChargeEditable?: boolean;
  paperCharge?: number;
}

export const ComparisonParcelCost = (props: Props) => {
  const {
    charge,
    cancelUpdateMarkup,
    updateMarkup,
    jobConfigId,
    quantityItemSerialNumber,
    comparatorItemSerialNumber,
    boxChargeEditable,
    paperCharge,
  } = props || {};
  const [parcelCost, setParcelCost] = useState<number>(Number(charge));
  useEffect(() => {
    setParcelCost(Number(charge));
  }, [charge]);
  return (
    <>
      {boxChargeEditable ? (
        <RevxInputNumber
          className="comparison-drawer-part-pct"
          style={{
            height: 20,
            padding: '2px 3px',
          }}
          min={0}
          value={parcelCost}
          // disabled={outsourceMarkupDisabled}
          onChange={async (e) => {
            if (parcelCost === +e) return;
            setParcelCost(+e);

            if (
              typeof cancelUpdateMarkup === 'function' &&
              typeof updateMarkup === 'function'
            ) {
              cancelUpdateMarkup();
              updateMarkup({
                jobConfigId: jobConfigId || '',
                quantityItemSerialNumber: quantityItemSerialNumber || 0,
                comparatorItemSerialNumber: comparatorItemSerialNumber || 0,
                parcelCost: +e,
                paperCharge,
              });
            }
          }}
          prefix="$"
          precision={2}
        />
      ) : (
        <ComparisonMoney value={parcelCost} />
      )}
    </>
  );
};
